import { Table } from '@tanstack/react-table';
import { isEmpty, isNil } from 'lodash';
import { MoreHorizontal } from 'lucide-react';
import { ComponentPropsWithoutRef, forwardRef, useMemo } from 'react';

import { DataTableFilterButton } from './data-table-filter-button';
import { getColumnDisplayName } from './utils';

export type DataTableMoreButtonProps<T = any> = ComponentPropsWithoutRef<'button'> & {
  table: Table<T>;
  excludes?: string[]; // 要排除更多操作的列字段名数组
  fieldMap?: Record<string, string>; // 过滤字段对应的显示名称映射，和 columns 定义一致的话，不需要提供
};

function noValue(filter: any): boolean {
  if (Array.isArray(filter.value) && isEmpty(filter.value)) {
    return true;
  }
  return isNil(filter.value);
}

export const DataTableMoreButton = forwardRef<HTMLButtonElement, DataTableMoreButtonProps>(
  ({ table, excludes = [], className, fieldMap, ...props }, ref) => {
    const columnFilters = table.getState().columnFilters;
    const moreFilterLabels = useMemo(() => {
      return columnFilters
        .filter((filter) => !excludes.includes(filter.id) && noValue(filter.value))
        .map((filter) => {
          if (fieldMap && filter.id in fieldMap) {
            return fieldMap[filter.id];
          }
          const column = table.getColumn(filter.id);
          return column ? getColumnDisplayName(column) : filter.id;
        });
    }, [table, columnFilters, excludes, fieldMap]);

    return (
      <DataTableFilterButton
        ref={ref}
        title="更多"
        className={className}
        selectedLabels={moreFilterLabels}
        icon={<MoreHorizontal />}
        {...props}
      />
    );
  }
);

DataTableMoreButton.displayName = 'DataTableMoreButton';
